import { Component, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { timelineParents } from '../../helpers/helpers';
import { JoiEvent } from 'src/app/store/events.era';
import { programsArray } from 'src/app/store/reselectors/programs.reselector';
import { Program } from 'src/app/store/programs.era';
import { performerDisplayTypes } from 'src/app/store/performers.era';
import { PAGE_NAME } from 'src/app/services/event.permissions.service';
import { Wrapper } from 'src/app/components/wrapper.component';
import { PublicNotesInfo } from 'globals/store/share.data';
import { ShareNotesService } from '../../services/share.notes.service';
import { getFacilitatorProgramTimeline } from 'globals/share/share.facilitator.functions';
import { TimelineComponent } from './../../components/timeline/timeline.component';
import { Dictionary } from '@ngrx/entity';
import { TopMenuComponent } from '../program/top.menu';
import { MobileMenuComponent } from 'src/app/components/menu/mobile-menu.component';
import { BinaryShareToggle } from '../share/binary-share-toggle.component';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { CommonModule } from '@angular/common';
import { LoaderPaneFragmentComponent } from 'src/app/components/loader/loader-pane-fragment.component';
import { traceNames } from 'src/app/services/performance.tracking.data';
@Component({
    selector: 'facilitator-program',
    template: `
<top-menu></top-menu>
<mobile-menu>
  <div class="mobile mobile-menu-bottom" *ngIf="is_loaded && !!timeline" [ngClass]="{ hidden: currentIndex < 0 }">
    <div class="title-holder" *ngIf="is_loaded">
      <icon icon="arrow_back_24px" (click)="showProgram(-1)"></icon>
      <div class="title">{{ programs[currentIndex]?.title || 'Unnamed '+ uiService.programTerm.btn +'...'}}</div>
    </div>
    <div style="flex:1" ></div>
    <icon [icon]="'grow'" (click)="$event.stopPropagation(); timeline.expandAll()"></icon>
    <icon [icon]="'shrink'" (click)="$event.stopPropagation(); timeline.collapseAll()"></icon>
  </div>
</mobile-menu>
<loader-pane-fragment *ngIf="!!currentIndex" [trace]="traceNames.viewFacilitatorNotes"></loader-pane-fragment>
<div class="no_date" *ngIf="is_loaded && (!programs || programs.length === 0)">Add programs in the program builder section</div>
<div class="program_items wrap680 box" *ngIf="currentIndex === -1 && !!programs?.length" >
  <div class="program_item" [ngClass]="{last:last}" (click)="showProgram(idx)" *ngFor="let p of programs; index as idx; last as last; trackBy:trackByProgram">
    {{p.title || 'Unnamed '+ uiService.programTerm.btn +'...'}}
  </div>
</div>

<ng-container *ngIf="currentIndex > -1">
  <div *ngIf="!is_loaded">
      <div class="background_text">Timeline content loading...</div>
  </div>
  <div *ngFor="let p of programs; index as idx; trackBy:trackByProgram" class="program_container" [ngClass]="{currentIndex:currentIndex===idx}" [ngStyle]="{left: (idx-currentIndex)*100 + '%'}">
    <loader-pane-fragment *ngIf="idx === currentIndex" [trace]="traceNames.viewFacilitatorNotes"></loader-pane-fragment>
    <event-timeline 
      *ngIf="single_columns[p.id]" 
      #timeline
      [performerDisplayType]="performerDisplayType"
      [data]="single_columns[p.id]"
      [parent]="timelineParent" 
      [readonly]="currentEvent?.is_readonly || permissionsService.readonly[page_name]"
      (increment)="showProgram($event)"
      (editFacilitatorNotes)="editFacilitatorNotes($event)"
    >
    <binary-share-toggle
      class="notes-top"
      [type]="'brief'"
      [shareType]="shareTypes.notes"
      [shareableFormat]="'oneLine'"
      [shareCode]="noteInfos[p.id]?.publishCode"
      [hint]="'Note: The shareable webpage is dynamic and will always load the current facilitator notes.'"
      [title]="'Facilitator Notes webpage'"
      [shareTitle]="'Your shareable webpage:'"
      [status]="noteInfos[p.id]?.status || 'Off'"
      (toggle)="toggleShare($event)"
    ></binary-share-toggle>
  
    </event-timeline>
  </div>
</ng-container>
    `,
    styleUrls: [`./facilitator.scss`, '../../page.scss'],
    standalone: true,
    imports: [TopMenuComponent, TimelineComponent, MobileMenuComponent, BinaryShareToggle, IconComponent, CommonModule, LoaderPaneFragmentComponent]
})
export class FacilitatorComponent extends Wrapper<FacilitatorComponent> {

  noteInfos: { [programId: string]: PublicNotesInfo }
  @ViewChild(TimelineComponent) timeline;
  programEntities: Dictionary<Program>
  traceNames = traceNames

  timeline_programs;
  single_column;
  multiple_column;
  is_loaded = false;
  no_dated_program = false;
  performerDisplayType = performerDisplayTypes.staticCardSmallHeader;
  single_columns: any;
  max_programs = 0;
  currentIndex = -1;
  mobile_date_index = 0;
  onsite_view = false;
  currentEvent: JoiEvent
  programs: Program[]
  page_name = PAGE_NAME.facilitator_notes;
  timelineParent = timelineParents.facilitator // AKA YOU

  constructor(private route: ActivatedRoute, private shareNotesService: ShareNotesService, private changeDetectorRef: ChangeDetectorRef) {
    super()
    this.subProp(this.store.select('shareables', 'notes'), 'noteInfos')
    this.subProp(this.store.select('programs','entities'), 'programEntities')

    this.subCallback(this.store.select('events','event'), event => {
      this.currentEvent = event
      this.single_columns = {}
      if (this.programs) this.prepare_timeline()
    })

    this.subCallback(this.route.params, params => {
      if (params.progIndex && params.progIndex > -1) {
        this.currentIndex = +params.progIndex;
      }
    })
    this.onsite_view = /onsite/.test(this.router.url)

    this.selectCallback(programsArray, null, (programs: Program[]) => {
      this.programs = programs
      // console.log({ programs })
      this.no_dated_program = programs.findIndex(prog => prog.date !== undefined) === -1;
      this.single_columns = {};
      this.prepare_timeline();

    })
    this.uiService.changePageTitle("Facilitator Notes", true)

  }

  
  async editFacilitatorNotes({ event, programId, sessionId }: { event: Event, programId: string, sessionId?: string }) {
    this.changeDetectorRef.detach()
    await this.programService.editFacilitatorNotes({ event, programId, sessionId }, this.dialog)
    this.changeDetectorRef.reattach()
  }

  toggleShare(share: boolean) {
    const programId = this.programs[this.currentIndex].id
    const infoShareable = this.noteInfos[programId]
    if (!infoShareable) this.shareNotesService.addNewSharedNotes(programId, this.eventService.eventId)
    else this.shareNotesService.changeNotesShareStatus({ ...infoShareable, status: share ? 'On' : 'Off' })
  }

  trackByFn(index, item) { return index; }

  
  prepare_timeline() {
    if (!this.currentEvent) return
    // console.log('this.program.programs = ', this.program.programs);
    this.single_column = [];
    this.max_programs = this.programs.length - 1;
    // console.log('this.programs ', this.programs);
    this.programs.forEach((p, index) => {
      const program_legend = {};
      program_legend[p.id] = p;
      const single_column = getFacilitatorProgramTimeline(p, this.currentEvent)
      this.single_columns[p.id] = {
        program_legend, onsite_view: this.onsite_view, currentIndex: index, single_column: single_column,
        multiple_column: [], title: p.title, facilitator_view: true, filtered_by: [] /* <== not sure what form this is supposed to take this.program.filtered_by */
      }
    });
    setTimeout(() => this.is_loaded = true, 0) // hack for being able to access timeline view child properties without change detector ref errors
  }

  actionFromMenu(ev) {
    if (ev === 'print') {
      this.uiService.print()
    }
  }

  trackByProgram(index, program: Program) {
    return program.id
  }

  showProgram(entry) {
    let idx = -1;
    if (typeof entry === 'number' && entry >= 0 && entry < this.programs.length) {
      idx = entry;
    }
    this.currentIndex = idx;
    const base = '/event/';

    const nav_array = [base + 'facilitator', this.currentEvent.eventId]
    if (idx > -1) nav_array.push(idx.toString());
    // console.log('show program', { nav_array })
    this.router.navigate(nav_array);
  }

}

